import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ClickIcon from "../../../../components/essentials/icon-buttons/click-icon/ClickIcon";
import "./JobsToolbar.scss";
import { selectUser } from "../../../../core/auth/authSlice";
import { User } from "../../../../shared/models";

const JobsToolbar: React.FC = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const user = useSelector(selectUser) as User;

	const isMyJobsSection = location.pathname.includes("/jobs/my-jobs");
	const pathSegments = location.pathname.split("/");
	// Get the tab name (e.g., "posted", "saved", "drafts", "applied")
	// The path is like: /jobs/my-jobs/posted/:userId
	const currentSubTab = pathSegments[pathSegments.length - 2];

	return (
		<div className="jobs-toolbar">
			{/* Show My Jobs tabs when in My Jobs section, otherwise show main tabs */}
			{isMyJobsSection ? (
				<div className="jobs-toolbar__my-jobs-tabs">
					<div className="jobs-toolbar__back-button">
						<ClickIcon
							icon="backarrow"
							onClick={() => navigate("/jobs")}
							size="s"
							color="rgba(255, 255, 255, 0.7)"
						/>
					</div>
					<div className="jobs-toolbar__tabs-container">
						<button
							className={`jobs-toolbar__tab ${
								currentSubTab === "posted" ? "jobs-toolbar__tab--active" : ""
							}`}
							onClick={() => navigate(`/jobs/my-jobs/posted/${user?.userId}`)}
						>
							Posted
						</button>
						<button
							className={`jobs-toolbar__tab ${
								currentSubTab === "saved" ? "jobs-toolbar__tab--active" : ""
							}`}
							onClick={() => navigate(`/jobs/my-jobs/saved/${user?.userId}`)}
						>
							Saved
						</button>
						<button
							className={`jobs-toolbar__tab ${
								currentSubTab === "drafts" ? "jobs-toolbar__tab--active" : ""
							}`}
							onClick={() => navigate(`/jobs/my-jobs/drafts/${user?.userId}`)}
						>
							Drafts
						</button>
						<button
							className={`jobs-toolbar__tab ${
								currentSubTab === "applied" ? "jobs-toolbar__tab--active" : ""
							}`}
							onClick={() => navigate(`/jobs/my-jobs/applied/${user?.userId}`)}
						>
							Applied
						</button>
					</div>
				</div>
			) : (
				<div className="jobs-toolbar__main-tabs">
					<button
						className="jobs-toolbar__tab"
						onClick={() => navigate(`/jobs/my-jobs/posted/${user?.userId}`)}
					>
						My Jobs
					</button>
					<button
						className="jobs-toolbar__tab jobs-toolbar__tab--add"
						onClick={() => navigate("/create-job")}
					>
						+ Add Job
					</button>
				</div>
			)}
		</div>
	);
};

export default JobsToolbar;
